import PaymentDetails from 'src/models/paymentDetails.js';
import PolicyHolder from 'src/models/policyHolder.js';
import i18n from 'src/i18n/index.js';

class Agreement {
  constructor(params) {
    this.agreementId = params.agreementId;
    this.agreementIdNumber = params.agreementIdNumber;
    this.collectivity = params.collectivity;
    this.contractCode = params.contractCode;
    this.hasBasicInsurance = params.hasBasicInsurance;
    this.policyHolders = params.policyHolders.map((holder) => new PolicyHolder(holder));
    this.paymentDetails = undefined;

    this.label = `${i18n.global.t('agreement-section.label.collectivity')} ${params.collectivity} (${i18n.global.t('agreement-section.label.contractCode')} ${params.contractCode})`;
    this.caption = `${i18n.global.t('agreement-section.caption.agreementId')} ${params.agreementIdNumber}`;

    return this;
  }

  addPaymentDetails(params) {
    this.paymentDetails = new PaymentDetails(params);
    return this;
  }
}
export { Agreement as default };
